module.exports = __webpack_public_path__ + "img/icon-tpvpos.aeaa438a.svg";